/*
  Fallback-Daten der Beauty-Airways-Seite — NUR für die Entwicklung.

  Die echte Seite bekommt ihren Inhalt aus Craft: cms/templates/_/pages/
  beauty-airways.twig übergibt diese Struktur als `page`-Attribut an
  <beauty-airways-root>. Dieses Modul greift nur, wenn das Attribut fehlt oder
  nicht parst — damit die Komponente ohne CMS-Anschluss startet (dasselbe
  Muster wie story.data.js beim Scrollytelling).

  DEUTLICH KLEINER ALS FRÜHER, und das ist der Punkt: Bühnen-Headline,
  Stationen, Terminus-Überschrift und die ganze Bordkarte sind keine Daten
  mehr, sondern Markup aus dem Twig (siehe die Slots dort). Was hier bleibt,
  ist genau das, was die Komponente selbst rendert und deshalb als Wert
  braucht:

    stage.hint         Beschriftung des Scroll-Hinweises
    labels.flightData  zugängliche Beschriftung der Fallblattanzeige
    terminus.rows      die Zeilen der Anzeigetafel; ihre Zellen entstehen im
                       JS (initBoard), sie können deshalb nicht aus dem Twig
                       kommen

  Ohne CMS bleibt die Seite damit ohne Texte — sie ist dann ein Gerüst zum
  Entwickeln der Mechanik, nicht mehr eine Demo mit Inhalten. Das ist Absicht:
  hartkodierte Demo-Texte an zwei Orten gehen erfahrungsgemäß auseinander.

  STRUKTUR = VERTRAG. Wer hier einen Schlüssel ändert, ändert ihn auch im
  Template — die Komponente kennt beide Quellen nur über diese eine Form.
*/
export const fallback = {
    stage: {
        hint: 'Scrollen',
    },
    labels: {
        flightData: 'Flugdaten',
    },
    terminus: {
        rows: ['30.11.2026', 'WIEN → MÜNCHEN → WIEN', '30 VIP-GÄSTE', '1 EXKLUSIVER BEAUTY DAY'],
    },
}
